module.exports = __webpack_public_path__ + "img/check-box-mark.9f50fdbe.svg";